(() => {
  class CodebrwnCarousel extends HTMLElement {
    connectedCallback() {
      this.scroller = this.querySelector('[data-carousel-scroller]');
      this.querySelectorAll('[data-carousel-direction]').forEach((button) => {
        button.addEventListener('click', () => this.scroll(button.dataset.carouselDirection));
      });
    }

    scroll(direction) {
      if (!this.scroller) return;
      const firstItem = this.scroller.querySelector('[data-carousel-item]');
      const distance = firstItem ? firstItem.getBoundingClientRect().width + 32 : this.scroller.clientWidth;
      this.scroller.scrollBy({
        left: direction === 'next' ? distance : -distance,
        behavior: 'smooth',
      });
    }
  }

  class CodebrwnVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.button = this.querySelector('[data-video-play]');
      if (!this.video || !this.button) return;

      this.button.addEventListener('click', () => {
        if (this.video.paused) {
          this.video.play();
        } else {
          this.video.pause();
        }
      });

      this.video.addEventListener('play', () => this.button.classList.add('is-playing'));
      this.video.addEventListener('pause', () => this.button.classList.remove('is-playing'));
    }
  }

  if (!customElements.get('codebrwn-carousel')) {
    customElements.define('codebrwn-carousel', CodebrwnCarousel);
  }

  if (!customElements.get('codebrwn-video')) {
    customElements.define('codebrwn-video', CodebrwnVideo);
  }
})();
